import { render, staticRenderFns } from "./SapHandleRecordStatPanel.vue?vue&type=template&id=f8319266&"
import script from "./SapHandleRecordStatPanel.vue?vue&type=script&lang=js&"
export * from "./SapHandleRecordStatPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports